// TODO: Implement upload document controller
import HttpClient from '../httpClient';

class UploadDocController extends HttpClient {
  uploadDocument = async (
    resumeFileData: string,
    coverLetterFileData?: string | null,
    jobId?: string,
    orgId?: string,
    token?: string,
  ) => {
    const response = await this.client.post(
      '/enterprise/upload-documents',
      {
        resumeFileData,
        coverLetterFileData,
        jobId,
        orgId,
      },
      {
        headers: {
          Authorization: token ?? '',
        },
      },
    );
    return response.data;
  };
}

export default new UploadDocController(
  process.env.REACT_APP_API_BASE_URL_DOCUMENTS_IMAGE,
);
